// extracted by mini-css-extract-plugin
export default {"title":"CustomModal_title__eqrQ8","crossIcon":"CustomModal_crossIcon__cUZV-"};